exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clinic-show-template .modal-dialog{max-width:75%}#clinic-show-template .content-editor{height:55vh}#clinic-show-template #show_template_content .ql-container{height:55vh;overflow-y:scroll}", ""]);

// exports
